<div class="wrapper-page-create-list">
  <div class="header-create-list">
    <button (click)="goBack()" class="custom-btn custom-btn--circle-outline">
      <img src="../../../assets/icons/icon-arrow-left.svg" alt="">
    </button>
  </div>
  <div class="wrapper-create-review">
    <form [formGroup]="reviewForm" (ngSubmit)="submitReview()">
      <div class="author-create-review">
        <img class="profile-image" [src]="loggedUser.profile_photo_url !== null ? loggedUser.profile_photo_url : '../../../../assets/images/avatar-user.png'" alt="">
        <span>{{loggedUser.name}}</span>
        <img *ngIf="(loggedUser.subscriptions | checkActiveRole) === UserRoles.expert" class="badge" src="../../../assets/icons/fill/icon-badge.svg" alt="">
        <img *ngIf="(loggedUser.subscriptions | checkActiveRole) === UserRoles.company" class="badge" src="../../../assets/icons/fill/icon-fill-company.svg" alt="">
      </div>
      <span class="label-create-review">{{'NEW_TEXT.you_are_posting_review_for_the_following' | translate}} {{reviewType === 'list' ? 'list' :
        'item'}}:</span>
      <div class="wrapper-tags">
        <div class="wrapper-tag list">
          <img src="../../../../../assets/icons/outline/icon-tag.svg" alt="">
          <span>{{reviewType === 'item' ? historyState?.name : historyState?.title}}</span>
        </div>
        <!--      <div class="wrapper-tag item">-->
        <!--        <img src="../../../../../assets/icons/outline/icon-tag.svg" alt="">-->
        <!--        <span>tag lorem ipsum</span>-->
        <!--      </div>-->
      </div>
      <div class="wrapper-add-rating">
        <img *ngFor="let star of stars; let i = index"
          src="{{ i < reviewForm.controls['rating'].value ? filledStar : outlinedStar }}" (click)="rate(i + 1)"
          alt="star">
      </div>
      <div class="wrapper-input textarea">
        <span class="label-input">
          {{'GENERAL.reviews' | translate}}
        </span>
        <div class="custom-input">
          <textarea formControlName="review" maxlength="200" [placeholder]="'LISTS.share_details_of_your_review' | translate"></textarea>
        </div>
        <div class="wrapper-message-description">
          <span class="label-info-input">{{'NEW_TEXT.the_maximum_length_of_a_review_description_is' | translate}} {{reviewForm.controls['review'].value?.length || 0 }}/200  {{'NEW_TEXT.characters' | translate}}.</span>
        </div>
      </div>
      <div class="wrapper-message-info">
        <img src="./assets/icons/outline/icon-outline-attention.svg" alt="">
        <span>{{'LISTS.next_48_hours_you_will_be_able_to_modify_this_review' | translate}}</span>
      </div>
      <button type="submit" [disabled]="!reviewForm.valid" class="custom-btn custom-btn--primary">
        <span>
          {{'LISTS.post' | translate}}
        </span>
      </button>
    </form>
  </div>
</div>
